import axios from 'axios';

const API_URL = `${import.meta.env.VITE_BACKEND_URL}/api`;

export const authApi = {
  signIn: async (email, password) => {
    const response = await axios.post(`${API_URL}/auth/signin`, {
      email,
      password
    });
    return response.data;
  },

  signUp: async (userData) => {
    const response = await axios.post(`${API_URL}/auth/signup`, userData);
    return response.data;
  },

  forgotPassword: async (email) => {
    const response = await axios.post(`${API_URL}/auth/forgot-password`, {
      email
    });
    return response.data;
  },

  resetPassword: async (token, newPassword) => {
    const response = await axios.post(`${API_URL}/auth/reset-password`, {
      token,
      newPassword
    });
    return response.data;
  },

  logout: async () => {
    const response = await axios.post(`${API_URL}/auth/signout`);
    return response.data;
  },

  getCurrentUser: async () => {
    const response = await axios.get(`${API_URL}/auth/me`);
    return response.data;
  },

  initiateGoogleSignIn: async () => {
    try {
      const response = await axios.get(`${API_URL}/auth/google-url`);
      if (response.status !== 200) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.data.url; // Return the URL
    } catch (error) {
      console.error('Error initiating Google sign-in:', error);
      throw error;
    }
  },

  createProfile: async (profileData) => {
    try {
      const response = await axios.post(`${API_URL}/profile/create`, profileData);
      if (response.status !== 200) {
        throw new Error('Failed to create profile');
      }
      return response.data;
    } catch (error) {
      console.error('Error creating profile:', error);
      throw error;
    }
  },

  updateProfile: async (profileData) => {
    try {
      const response = await axios.put(`${API_URL}/profile/update`, profileData);
      if (response.status !== 200) {
        throw new Error('Failed to update profile');
      }
      return response.data;
    } catch (error) {
      console.error('Error updating profile:', error);
      throw error;
    }
  },

  getProfile: async () => {
    try {
      const response = await axios.get(`${API_URL}/profile/`);
      if (response.status !== 200) {
        throw new Error('Failed to fetch profile');
      }
      return response.data;
    } catch (error) {
      console.error('Error fetching profile:', error);
      throw error;
    }
  }
}; 